import { Button, Card, Checkbox, Col, DatePicker,  InputNumber, Row, Select } from "antd";
import { grayheader, cardmargin } from "../../CSSReferences";
import { Component } from "react";
import { sendlicensedata, mandant, modules } from "../typing/generalType";
import { tolerancePlaceholder } from "../typing/loginstate";
import { FormattedMessage } from 'react-intl';
import { injectIntl } from '../../../intl-compat';

const { Option } = Select;

export interface LocalProps{
  //defince local porperies (maybe as tag parameter)
  // ONLY TYPES; NO VALUES
    id:string;
    url:string;
    mandant:mandant[];
    newlicense:sendlicensedata,
    modules:modules[],
    selected:string[],
    toleranceDefault:number | null,
  // FUNCTIONS ALSO INCLUDE
  onSubmit: (data:any) => void;
  onFormChange: (data:any, type:string) => void;
  onSelectJob:(value:any, checked:any) => void;
  requestLoadOfStuff:() => void;
}


       
// noclass because of Forms crap
const MyCredInputView = class CredInputView extends Component<LocalProps & {intl:any}, {}> 
  {
    
onOk = (value:any) => {
  console.log('onOk: ', value);
}
onSubmit = (data: any)  => {
    // Die angehakten Module gehoeren an die Lizenz. Sie lagen bisher neben ihr
    // im Zustand und wurden beim Absenden nicht mitgenommen - das Formular bot
    // eine Auswahl an, die nirgends ankam.
    this.props.onSubmit({ ...this.props.newlicense, module: this.props.selected });
  }

  onChangeClient=(value:any) => {
    this.props.onFormChange(value, "client");
  }

OnChangeExpTime=(value:any) => {
    this.props.onFormChange(value, "expTime");
  }
onChangeNumber=(value:any) => {
    this.props.onFormChange(value, "numberOfTarget");
  }
  OnChangeTolerance=(value:any) => {
    this.props.onFormChange(value, "targetTolerance");
  }
  OnChangeName=(value:any) => {
    this.props.onFormChange(value.target.value, "name");
  }
  OnChangeBranch=(value:any) => {
    this.props.onFormChange(value, "branch");
  }
  OnChangeEdition=(value:any) => {
    this.props.onFormChange(value, "edition");
  }
  OnChangeSoftware=(value:any) => {
    this.props.onFormChange(value, "software");
  }
componentDidMount()
{
  setTimeout(() => {
    this.props.requestLoadOfStuff();
    },
    500)
}

OnSelectJob = (data:any) => {
  this.props.onSelectJob(data.target.value, data.target.checked);
}

 //choosenentry = this.props.newlicense.;
CreateModulesSelect = () =>{
  return(
    <div >
    {this.props.modules.map((moditem:modules) => {
      return(
        <Checkbox
          value={moditem.uuid}
          key={moditem.uuid}
          checked={this.props.selected.includes(moditem.uuid)}
          onChange={this.OnSelectJob}
          title={moditem.description}
        >{moditem.name}</Checkbox>
          )
        }
        
      )
    }
    </div>
  )
}

 
CreateMandantList = () =>{
  return(
    <Select defaultValue="Mandant" style={{width:165}} onChange={this.onChangeClient}>
    {this.props.mandant.map((creditem) => {
      return(
        <Option key={creditem.uuid} value={creditem.uuid}>{creditem.name} </Option>
          )
        }
      )
    }
  </Select>
  )
}

// CreateBranchList = () =>{
//   return(
//     <Select defaultValue="Branch" style={{width:165}} onChange={this.onChangeBranch}>
//     {this.props.mandant.map((creditem) => {
//       return(
//         <Option key={creditem.uuid} value={creditem.uuid}>{creditem.name} </Option>
//           )
//         }
//       )
//     }
//   </Select>
//   )
// }

render(){
return (
  <Row gutter={16}>  
      <Col span={24}>
    <Card title="Generate new License" style={cardmargin} hoverable styles={{ header: grayheader }}>
        <Row gutter={16}>
          <Col span={8}>
            <label>{<FormattedMessage id="Client" defaultMessage="Client" />} </label>
          </Col>
          <Col span={10}>  
          {this.CreateMandantList() as any}  
          </Col>
        </Row> 
        <Row gutter={16}>
        <Col span={8}>
            <label>{<FormattedMessage id="ClientName" defaultMessage="Client Name" />} </label>
          </Col>
          <Col span={4}>
          <input placeholder="Client Name" onChange={this.OnChangeName}/>
            </Col>
            </Row>
        <Row gutter={16}>
          <Col span={8}>
            <label>{<FormattedMessage id="Expiration Time" defaultMessage="Expiration Time" />} </label>
          </Col>
          <Col span={10}>    
          <DatePicker showTime onChange={this.OnChangeExpTime} onOk={this.onOk} />
          </Col>
        </Row> 
        <Row gutter={16}>
          <Col span={8}>
            <label>{<FormattedMessage id="NumberOfTargets" defaultMessage="Number Of Targets" />} 
</label>
          </Col>
          <Col span={10}>    
          <InputNumber min={1} max={10000} placeholder={(this.props.intl.formatMessage({id:"NumberOfTargets", defaultMessage:"Number of targets"}))} onChange={this.onChangeNumber} />
          {/* <input  placeholder={(this.props.intl.formatMessage({id:"NumberOfTargets", defaultMessage:"Number of targets"}))} onChange={this.onChangeNumber} /> */}
          </Col>
        </Row> 
        <Row gutter={16}>
          <Col span={8}>
            <label>{<FormattedMessage id="TargetTolerance" defaultMessage="Target tolerance (%)" />} </label>
          </Col>
          <Col span={10}>
          {/* Empty = hub default. From the licensed number on the spoke warns,
              above number + tolerance it refuses new targets and scans. */}
          <InputNumber min={0} max={100} precision={0} style={{width:165}}
            value={this.props.newlicense.targetTolerancePercent ?? null}
            placeholder={tolerancePlaceholder(this.props.intl.formatMessage({id:"HubDefault", defaultMessage:"default"}), this.props.toleranceDefault)}
            onChange={this.OnChangeTolerance} />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <label>{<FormattedMessage id="Branch" defaultMessage="Branch" />} 
        </label>
          </Col>
          <Col span={10}>    
          <Select defaultValue="Please choose" style={{width:165}} onChange={this.OnChangeBranch}>
          <Option key="nightly" value="nightly">Nightly</Option>
          <Option key="alpha" value="alpha">Alpha</Option>
          <Option key="beta" value="beta">Beta</Option>
          <Option key="release" value="release">Release</Option>
          </Select>
          </Col>
        </Row> 
        <Row gutter={16}>
          <Col span={8}>
            <label>{<FormattedMessage id="Editon" defaultMessage="Edition" />} 
        </label>
          </Col>
          <Col span={10}>    
          <Select defaultValue="Please choose" style={{width:165}} onChange={this.OnChangeEdition}>
          {/* Licence tiers since 28.09.2026: each contains the one below;
              modules ticked below come on top of the tier's features. */}
          <Option key="free" value="free">Free</Option>
          <Option key="business" value="business">Business</Option>
          <Option key="enterprise" value="enterprise">Enterprise</Option>
          </Select>
          </Col>
        </Row> 
        <Row gutter={16}>
          <Col span={8}>
            <label>{<FormattedMessage id="Software" defaultMessage="Software" />} 
        </label>
          </Col>
          <Col span={10}>    
          <Select defaultValue="Please choose" style={{width:165}} onChange={this.OnChangeSoftware}>
          <Option key="Vodin" value="Vodin">Vodin</Option>
          </Select>
          </Col>
        </Row> 
        <Row gutter={16}>
          <Col span={8}>
            <label>	<FormattedMessage id="Modules" defaultMessage="modules" /> </label>
          </Col>
          <Col span={16}>    
          {this.CreateModulesSelect() as any}  
          </Col>
        </Row> 
        <Row gutter={16}>
        <Col span={4}></Col>
        <Button type="primary" htmlType="submit" onClick={this.onSubmit} >
          <FormattedMessage id="Generate License" defaultMessage="Generate License" />
        </Button>
        </Row>
      </Card>
    </Col>
    <Col span={8}></Col>
    </Row>
    )
  }
};
export default injectIntl(MyCredInputView);